import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#111928",
      d: "M6.713 6.006 9.36 3.36a.5.5 0 1 0-.707-.707L6.006 5.299 3.36 2.653a.5.5 0 0 0-.707.707l2.646 2.646-2.646 2.647a.5.5 0 1 0 .707.707l2.646-2.647L8.653 9.36a.5.5 0 0 0 .707-.707L6.713 6.006Z"
    }, null, -1)
  ]))]))
}
export default { render: render }